module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABDSURBVDiNY2CgNvj//3/D////HYhVz4RDfP////8bKHHF/v8QMPCGNAx+Q3DFAvUARV6gVDP50ThwmqEGOFAU56QCALFSgIxz49qwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3.1 返回1 (2).png
// module id = mL21
// module chunks = 0